var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutOfSyncIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 39,
    viewBox: "0 0 28 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0629 5.96359C23.1212 5.84532 23.0511 5.70395 22.9217 5.67879L13.2122 3.79146C13.1202 3.77357 13.0281 3.82202 12.9907 3.908L5.71415 20.6334C5.66565 20.7449 5.727 20.8735 5.84417 20.9059L11.0071 22.3357C11.1078 22.3636 11.17 22.4642 11.1501 22.5667L8.64347 35.4621C8.60513 35.6593 8.849 35.7836 8.98605 35.6367L24.8551 18.6224C24.9623 18.5075 24.9012 18.3196 24.747 18.2896L17.9193 16.9625C17.7898 16.9373 17.7197 16.7959 17.7781 16.6777L23.0629 5.96359Z",
    fill: "#9097A3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.0972,
    width: 3,
    height: 39,
    transform: "rotate(36.3159 23.0972 0)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.0972,
    y: 2,
    width: 3,
    height: 39,
    transform: "rotate(36.3159 25.0972 2)",
    fill: "#9097A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutOfSyncIcon);
export default __webpack_public_path__ + "static/media/out_of_sync_icon.4dc0d4e019e2099091a28f603a45ffc8.svg";
export { ForwardRef as ReactComponent };